import { render } from "./AccountVerificationFailed.vue?vue&type=template&id=40d256f4&scoped=true"
import script from "./AccountVerificationFailed.vue?vue&type=script&lang=js"
export * from "./AccountVerificationFailed.vue?vue&type=script&lang=js"

import "./AccountVerificationFailed.vue?vue&type=style&index=0&id=40d256f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d256f4"]])

export default __exports__